module.exports = __webpack_public_path__ + "img/全屏.e7d4046a.svg";